<template>
    <div class="barcode-info-container">
        <div class="container">
            <CodeScannerGeneric @codeScanned="handleCodeScanned" />
            <div class="form lockKeyboardCons">
                <div class="config-item">
                    <div class="label-container">
                        <label v-text="getString('cracha')"></label>
                    </div>
                    <div id="consumer" ref="consumerDiv" class="div-input-android" data-clarity-mask="true"></div>
                </div>
            </div>

            <div class="barcode-info">
                <img :src="imgBarCode" />
                <p v-text="getString('bar_code_cracha')"></p>
            </div>
            <div class="message-container">
                <p v-text="message.text" :class="{'error': message.type === 'error', 'success': message.type === 'success', 'info': message.type === 'info'}"></p>
            </div>
            <div class="login-button-container">
                <DefaultButton v-for="(button, key) in buttons" :key="key" :text="button.text"
                    @defaultBtnClick="button.action" :disabled="button.disabled" :outlined="true"></DefaultButton>
            </div>
        </div>
    </div>
</template>

<script>
import DefaultButton from '@/components/DefaultButton'
import IdentifiedConsumerController from '@/assets/controllers/IdentifiedConsumerController'
import LocaleController from '@/assets/controllers/LocaleController'
import CodeScannerGeneric from '@/components/CodeScannerGeneric.vue'

export default {
    name: 'ConsumerLoginBadge',
    components: {
        DefaultButton,
        CodeScannerGeneric
    },
    data () {
        return {
            badgeCode: '',
            rawConsumer: null,
            consumer: null,
            controlsEnabled: true,
            consumerName: null,
            imgBarCode: require('../../../static/icons/ic-codigo-barras.png'),
            buttons: [
                {
                    text: this.getCancelText(),
                    action: this.cancelLogin,
                    disabled: false
                }
            ],
            message: {
                text: '',
                type: 'info'
            }
        }
    },
    mounted () {
        //  this.fillConsumerId()
        console.log('this.$refs.consumerDiv', this.$refs.consumerDiv)
    },
    beforeDestroy () {
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        fillConsumerId: function () {
            try {
                if (IdentifiedConsumerController.userIsLogged()) {
                    setTimeout(() => {
                        let consumerData = IdentifiedConsumerController.getConsumerData()
                        this.badgeCode = consumerData.consumerId
                        this.$refs.consumerDiv.innerText = this.badgeCode.replace(/\w/g, '*')
                    }, 500)
                }
            } catch (e) {
                console.log(e)
            }
        },
        validateInputs: function () {
            let result = { isValid: true, message: '' }

            if (!this.badgeCode) {
                result.isValid = false
                result.message = this.getString('todos_campos_obrigatorios')
                return result
            }

            this.badgeCode = this.badgeCode.trim()

            if (this.badgeCode.length === 0) {
                result.isValid = false
                result.message = this.getString('todos_campos_obrigatorios')
                return result
            }

            return result
        },
        handleCodeScanned: function (code) {
            this.badgeCode = code
            this.$refs.consumerDiv.innerText = ''
            this.$refs.consumerDiv.innerText = this.badgeCode.replace(/\w/g, '*')
            let inputResult = this.validateInputs()
            if (inputResult.isValid) {
                this.loginWithBadge()
            } else {
                this.message.text = inputResult.message
                this.message.type = 'error'
            }
        },
        loginWithBadge: async function () {
            this.message.text = this.getString('aguarde_enquanto_realizamos_o_login')
            this.message.type = 'info'
            let result = await IdentifiedConsumerController.loginWithBadge(this.badgeCode)
            console.log('result', result)
            if (result.success) {
                this.message.text = this.getString('login_realizado_com_sucesso')
                this.message.type = 'success'
                this.$emit('loginSuccess')
            } else {
                this.message.text = result.message || this.getString('nao_foi_possivel_realizar_login')
                this.message.type = 'error'
            }
            setTimeout(() => {
                this.$refs.consumerDiv.innerText = ''
                this.badgeCode = ''
                this.controlsEnabled = true
                this.$emit('enableOverlayClick')
            }, 2000)
        },
        cancelLogin: function () {
            IdentifiedConsumerController.userLogout()
            IdentifiedConsumerController.clearConsumerData()
            this.$emit('cancelLogin')
        },
        getCancelText: function () {
            return this.$router.currentRoute.name === 'Payment' ? this.getString('cancelar') : this.getString('nao_quero_identificar')
        }
    }
}
</script>

<style scoped lang='less'>
@import (reference) url("../../assets/common.less");

.barcode-info-container {
    height: 100%;
    box-sizing: border-box;

    .container {
        height: 100%;

        .form {
            display: flex;
            flex-direction: column;
            justify-content: center;
            width: 100%;
            height: 200px;
            .config-item {
                display: flex;
                flex-direction: column;
                align-items: start;
                justify-content: space-between;

                label {
                    font-size: 30px;
                    position: relative;
                    display: inline-block;
                    margin: 10px 0 20px 0;
                }

                .div-input-android {
                    position: relative;
                    display: flex;
                    align-items: center;
                    font-size: 2.2rem;
                    min-height: 40px;
                    height: 70px;
                    background: rgb(241, 241, 241);
                    color: #222;
                    border: 2px solid rgb(187, 187, 187);
                    padding: 0 20px;
                    width: 100%;
                    box-sizing: border-box;
                    border-radius: 10px;
                    transition: all 0.2s ease;
                }
            }
        }

        .barcode-info {
            margin: 10px 0;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            box-sizing: border-box;

            img {
                width: 300px;
                height: 150px;
            }

            p {
                text-align: center;
                font-size: 28px;
                margin: 10px;
            }
        }

        .login-button-container {
            display: flex;
            flex-direction: column;
            justify-content: center;
            margin: 30px auto;
            width: 100%;
            margin-top: 200px;

            button {
                width: 100%;
            }
        }
        .message-container {
            margin: 10px 0;
            min-height: 24px;
            text-align: center;
            font-size: 30px;
            .error {
                color: #d32f2f;
            }
            .success {
                color: #388e3c;
            }
            .info {
                color: #1565c0;
            }
        }
    }
}

@media (min-width: 699px) and (max-width: 1025px) {
    .barcode-info-container {
        .container {
            .form {
                display: flex;
                flex-direction: column;
                justify-content: center;
                width: 100%;
                height: 200px;

                .config-item {
                    display: flex;
                    flex-direction: column;
                    align-items: start;
                    justify-content: space-between;

                    label {
                        font-size: 30px;
                        position: relative;
                        display: inline-block;
                        margin: 10px 0 20px 0;
                    }

                    .div-input-android {
                        position: relative;
                        display: flex;
                        align-items: center;
                        font-size: 2.2rem;
                        min-height: 40px;
                        height: 70px;
                        background: rgb(241, 241, 241);
                        color: #222;
                        border: 2px solid rgb(187, 187, 187);
                        padding: 0 20px;
                        width: 100%;
                        box-sizing: border-box;
                        border-radius: 10px;
                        transition: all 0.2s ease;
                    }
                }
            }

            .barcode-info {
                margin: 10px 0;

                img {
                    width: 240px;
                    height: 120px;
                }

                p {
                    text-align: center;
                    font-size: 28px;
                    margin: 10px;
                }
            }

            .login-button-container {
                display: flex;
                flex-direction: row;
                justify-content: center;
                margin: 120px auto 30px auto;
                width: 100%;
            }
            .message-container {
                font-size: 25px;
            }
        }
    }
}

@media (max-width: 698px) {
    .barcode-info-container {
        .container {
            .form {
                height: 150px;
                .config-item {
                    label {
                        font-size: 18px;
                        margin: 10px 0 10px 0;
                    }

                    .div-input-android {
                        font-size: 1.2rem;
                        min-height: 40px;
                        height: 40px;
                        border: 1px solid rgb(187, 187, 187);
                        padding: 5px 10px;
                        border-radius: 5px;
                    }
                }
            }

            .barcode-info {
                margin: 5px 0;
                img {
                    width: 150px;
                    height: 75px;
                }

                p {
                    text-align: center;
                    font-size: 16px;
                }
            }

            .login-button-container {
                display: flex;
                flex-direction: column;
                justify-content: center;
                margin: 30px auto;
                width: 100%;
                margin-top: 50px;

                button {
                    width: 100%;
                }
            }
            .message-container {
                font-size: 20px;
            }
        }
    }
}

@media (orientation: landscape) and (max-width: 1025px) {
    .barcode-info-container {
        .container {
            .form {
                height: 155px;

                .config-item {
                    label {
                        font-size: 22px;
                        margin: 8px 0 12px 0;
                    }

                    .div-input-android {
                        font-size: 1.5rem;
                        min-height: 36px;
                        height: 52px;
                        padding: 0 16px;
                        border-radius: 8px;
                    }
                }
            }

            .barcode-info {
                margin: 8px 0;

                img {
                    width: 200px;
                    height: 100px;
                }

                p {
                    font-size: 22px;
                    margin: 8px;
                }
            }

            .login-button-container {
                margin: 70px auto 24px auto;
            }
            .message-container {
                font-size: 18px;
            }
        }
    }
}

@media (orientation: landscape) and (min-width: 1026px) and (max-width: 1367px) {
    .barcode-info-container {
        .container {
            .form {
                height: 185px;

                .config-item {
                    label {
                        font-size: 28px;
                        margin: 8px 0 16px 0;
                    }

                    .div-input-android {
                        font-size: 2rem;
                        min-height: 38px;
                        height: 64px;
                        padding: 0 18px;
                        border-radius: 9px;
                    }
                }
            }

            .barcode-info {
                margin: 9px 0;

                img {
                    width: 270px;
                    height: 135px;
                }

                p {
                    font-size: 26px;
                    margin: 9px;
                }
            }

            .login-button-container {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                margin: 100px auto 28px auto;
            }
            .message-container {
                font-size: 20px;
            }
        }
    }
}

@media (orientation: landscape) and (min-width: 1368px) {
    .barcode-info-container {
        .container {
            .form {
                height: 200px;

                .config-item {
                    label {
                        font-size: 30px;
                        margin: 10px 0 18px 0;
                    }

                    .div-input-android {
                        font-size: 2.15rem;
                        min-height: 40px;
                        height: 68px;
                        padding: 0 20px;
                        border-radius: 10px;
                    }
                }
            }

            .barcode-info {
                margin: 10px 0;

                img {
                    width: 290px;
                    height: 145px;
                }

                p {
                    font-size: 28px;
                    margin: 10px;
                }
            }

            .login-button-container {
                margin: 170px auto 30px auto;
            }
            .message-container {
                font-size: 22px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/consumerLogin/ConsumerLoginBadge.vue